module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("模拟OpenApi流程")]), _c('div', {
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getToken
    }
  }, [_vm._v("获取token")]), _c('p', [_vm._v(_vm._s(_vm.token))])], 1), _c('div', {
    staticStyle: {
      "padding": "10px 0px",
      "width": "30%"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商户ID"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.shopId),
      callback: function($$v) {
        _vm.$set(_vm.form, "shopId", $$v)
      },
      expression: "form.shopId"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "商户名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.shopName),
      callback: function($$v) {
        _vm.$set(_vm.form, "shopName", $$v)
      },
      expression: "form.shopName"
    }
  })], 1)], 1)], 1), _c('div', {
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getTransferUrl
    }
  }, [_vm._v("获取中转页URL和流水号")]), _c('p', [_vm._v(_vm._s(_vm.serialNumber))])], 1), _c('div', {
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getThirdPartyParameter
    }
  }, [_vm._v("通过流水号获取参数")]), _c('p', {
    staticStyle: {
      "padding-bottom": "10px",
      "color": "#F56C6C"
    }
  }, [_vm._v("用于查看传的参数是否正确，此按钮与下一按钮调同一个接口，不能同时使用，流水号会失效")]), _c('p', [_vm._v(_vm._s(_vm.jsonStr))])], 1), _c('div', {
    staticStyle: {
      "padding": "10px 0px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goTransferUrl
    }
  }, [_vm._v("跳转测试")])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-365ff082", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-365ff082","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/test.vue
// module id = 1192
// module chunks = 2